import { ActionIcon, Box, Button, Divider, Group, Stack, Text, TextInput } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import * as R from "ramda";
import React from "react";
import { ISJArapport } from "../../../../../mc-shared/reportSchemas/sjaSchema";

const SJADeltagere: React.FC<{
  editData: ISJArapport;
  updateData: (key: string, value: any) => void;
}> = ({ editData, updateData }) => {
  const updateDeltagere = (index: number, key: string, value: string) => {
    let deltagere = R.clone(editData.deltagere);
    deltagere[index][key] = value;
    updateData("deltagere", deltagere);
  };

  const addNewRow = () => {
    const newDeltager = {
      navn: "",
      avdSeksjon: "",
    };

    const updatedDeltagere = [...editData.deltagere, newDeltager];

    updateData("deltagere", updatedDeltagere);

    return updatedDeltagere;
  };

  const removeRow = (index: number) => {
    const updatedDeltagere = [...editData.deltagere];

    updatedDeltagere.splice(index, 1);
    updateData("deltagere", updatedDeltagere);
  };

  return (
    <Box w="50%">
      <Divider
        mb="sm"
        label={
          <Text fz="lg" fw={600}>
            Deltagere
          </Text>
        }
        labelPosition="left"
      />
      <Button size="sm" onClick={addNewRow} mb="sm">
        Legg til deltager
      </Button>
      <Stack>
        {editData.deltagere?.map((deltager, index) => (
          <Group key={index} align="center" gap="xs">
            <TextInput
              placeholder="Navn"
              value={deltager.navn}
              onChange={(e) => updateDeltagere(index, "navn", e.currentTarget.value)}
              size="sm"
              w={300}
            />
            <TextInput
              placeholder="Avd/Seksjon"
              value={deltager.avdSeksjon}
              onChange={(e) => updateDeltagere(index, "avdSeksjon", e.currentTarget.value)}
              size="sm"
              w={300}
            />
            <ActionIcon color="red" variant="subtle" size="sm" onClick={() => removeRow(index)}>
              <IconTrash />
            </ActionIcon>
          </Group>
        ))}
      </Stack>
    </Box>
  );
};

export default SJADeltagere;
